require('./notificationView.scss');

// @ vendor
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const trim = require('lodash/string/trim');
const { withRouter } = require('react-router-dom');

// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ actions
const userNotificationsActions = require('actions/userNotifications');
const openYoungCardChores = require('actions/openYoungCardChores');
const openYoungCardMoneyRequest = require('actions/openYoungCardMoneyRequest');
const openYoungCardSavings = require('actions/openYoungCardSavings');

// @ components
const UserNotificationsSection = require('components/userNotifications/userNotificationsSection/userNotificationsSection');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

//@constants
const {
    NOTIFICATIONS_STATUS_PENDING,
    NOTIFICATIONS_STATUS_DELIVERED,
    NOTIFICATIONS_STATUS_ERROR,
    NOTIFICATION_MESSAGE_TYPE_DISCLAIMER
} = require('constants/index');
const { NOTIFICATIONS_MANAGEMENT } = require('constants/flagBasedFeatures');

class NotificationView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            notificationCount : 0
        };
        this.isMessageNotADisclaimer = this.isMessageNotADisclaimer.bind(this);
        this.isUnreadNotification = this.isUnreadNotification.bind(this);
    }

    componentDidMount() {
        if (this.props.immLoginState.get('isAuthenticated')){
            this.props.requestUserNotifications();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immUserNotifications } = nextProps;
        const immNotificationsList = immUserNotifications.get('notifications');
        if(immNotificationsList.size !== this.state.notificationCount){
            this.setState({
                notificationCount: immNotificationsList.size
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.state.notificationCount !== nextState.notificationCount) {
            const { immUserNotifications, setUserNotifications } = nextProps;
            const immNotificationsList = immUserNotifications.get('notifications');
            if (immNotificationsList.size > 0) {
                const validNotificationsToDisplay = immNotificationsList.filter(
                    immNotification => this.isMessageNotADisclaimer(immNotification.get('messageType')) && this.isUnreadNotification(immNotification.get('deliveryStatus'))
                );
                const unreadNotificationIds =  validNotificationsToDisplay.map(notification => notification.get('messageId'));
                unreadNotificationIds.size && setUserNotifications(unreadNotificationIds);
            }
        }
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    handleGoToNotificationManagement = () => {
        this.props.history.push("/myprofile/notification/management")
    }

    isMessageNotADisclaimer(messageType) {
        return trim(messageType).toUpperCase() !== NOTIFICATION_MESSAGE_TYPE_DISCLAIMER;
    }

    isUnreadNotification(status) {
        return (status === NOTIFICATIONS_STATUS_PENDING || status === NOTIFICATIONS_STATUS_DELIVERED || status === NOTIFICATIONS_STATUS_ERROR);
    }

    renderButtonCover = () => {
        return (
            <FeatureTogglingRender notAllowedProductKey={NOTIFICATIONS_MANAGEMENT} >
                <div>
                    <OKButton modifier="secondary" onClick={() => this.handleGoToNotificationManagement()}>
                        <FormattedText value="notificationManagement-coverButton" />
                    </OKButton>
                </div>
            </FeatureTogglingRender>
        );
    }

    render() {
        const {
            clearFilters,
            getChoreDetail,
            flagBasedFeatures,
            immCards,
            immUserNotifications,
            openYoungCardChores,
            requestNextUserNotificationsPage,
            requestUserNotifications,
            setNotificationsFilters,
            setUserNotifications,
            getMoneyRequestDetails,
            moneySavingsRequestDetails
        } = this.props;
        const title = <FormattedText value="userNotifications-notifications" />

        return (
            <div>
                <div className="container-fluid user-notifications--header-identifier">
                    <div className="row">
                        <OKCover size="small" section="pg" customClass="col-xs-12">
                            <OKHeaderLanding title={title}>
                                {this.renderButtonCover()}
                            </OKHeaderLanding>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    <div className="col-md-12">
                                        <UserNotificationsSection
                                            clearFilters={clearFilters}
                                            getChoreDetail={getChoreDetail}
                                            flagBasedFeatures={flagBasedFeatures}
                                            immCards={immCards}
                                            immFilters={immUserNotifications.get('filters')}
                                            immUserNotifications={immUserNotifications}
                                            openYoungCardChores={openYoungCardChores}
                                            requestNextUserNotificationsPage={requestNextUserNotificationsPage}
                                            requestUserNotifications={requestUserNotifications}
                                            setNotificationsFilters={setNotificationsFilters}
                                            setUserNotifications={setUserNotifications}
                                            getMoneyRequestDetails={getMoneyRequestDetails}
                                            moneySavingsRequestDetails={moneySavingsRequestDetails}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-6 col-md-12">
                                        <CallMeBack isSmall={true} pageTitle={title} hasEntrance={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NotificationView.propTypes = {
    clearFilters: PropTypes.func,
    getChoreDetail: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immLoginState: PropTypes.object,
    immCards: PropTypes.object.isRequired,
    immTransactions: PropTypes.object.isRequired,
    immUserNotifications: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    moneySavingsRequestDetails: PropTypes.func.isRequired,
    requestNextUserNotificationsPage: PropTypes.func,
    requestUserNotifications: PropTypes.func.isRequired,
    setNotificationsFilters: PropTypes.func.isRequired,
    setUserNotifications: PropTypes.func.isRequired,
    getMoneyRequestDetails: PropTypes.func.isRequired
};

module.exports.constructor = NotificationView;
module.exports.NotificationView = connect(
    state => ({
        immLoginState: state.okLogin,
        immUserNotifications: state.userNotifications,
        immTransactions: state.cardsTransactions,
        immCards: state.cards,
        flagBasedFeatures: state.flagBasedFeatures,
        openYoungCardChores: state.openYoungCardChores
    }),{
        clearFilters: userNotificationsActions.clearUserNotificationsFilters,
        getChoreDetail: openYoungCardChores.getChoreDetail,
        getMoneyRequestDetails: openYoungCardMoneyRequest.getMoneyRequestDetails,
        moneySavingsRequestDetails: openYoungCardSavings.moneySavingsRequestDetails,
        requestNextUserNotificationsPage: userNotificationsActions.requestNextUserNotificationsPage,
        requestUserNotifications: userNotificationsActions.requestUserNotifications,
        setNotificationsFilters: userNotificationsActions.setNotificationsFilters,
        setUserNotifications: userNotificationsActions.setUserNotifications
    })(withRouter(NotificationView));
